import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  isAuthenticatedPage,
  isSuccessSigninExternalClientPage,
} from '../../utils/url';
import { GetUserInfoResponse } from '../httpClients/OIDCAuthenticationClient/api.schema';
import { OIDCAuthenticationClient } from '../httpClients/OIDCAuthenticationClient/OIDCAuthenticationClient';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<GetUserInfoResponse>,
  'queryKey' | 'queryFn'
>;

export const useOIDCUserInfoQuery = (queryOptions: OmittedQueryOptions = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.OIDC_USER_INFO],
    queryFn: OIDCAuthenticationClient.getUserInfo,
    enabled: isAuthenticatedPage() || isSuccessSigninExternalClientPage(),
    //TODO: Review caching strategy
    //https://linear.app/qodo/issue/PLT-2808/fe-review-caching-strategy-fpr-oidc
    gcTime: 0, // Don't cache the data - garbage collect immediately
    staleTime: 0, // Always consider data stale
    ...queryOptions,
  });
